import {
  COOKIE_OPTIONS,
  COOKIE_ACCESS_TOKEN_NAME,
  COOKIE_REFRESH_TOKEN_NAME,
  COOKIE_ROLE_NAME
} from "constants/common";
import { useCookies } from "react-cookie";

import { UserRole } from "../constants/userRole";

const useAuthTokens = () => {
  const [cookie, setCookie, removeCookie] = useCookies();

  const setTokens = (
    accessToken: string,
    refreshToken: string,
    role?: UserRole
  ) => {
    setCookie(COOKIE_ACCESS_TOKEN_NAME, accessToken, COOKIE_OPTIONS);
    setCookie(COOKIE_REFRESH_TOKEN_NAME, refreshToken, COOKIE_OPTIONS);
    if (role) {
      setCookie(COOKIE_ROLE_NAME, role, COOKIE_OPTIONS);
    }
  };

  const removeTokens = () => {
    removeCookie(COOKIE_ACCESS_TOKEN_NAME, COOKIE_OPTIONS);
    removeCookie(COOKIE_REFRESH_TOKEN_NAME, COOKIE_OPTIONS);
    removeCookie(COOKIE_ROLE_NAME, COOKIE_OPTIONS);
  };

  return {
    accessToken: cookie[COOKIE_ACCESS_TOKEN_NAME],
    refreshToken: cookie[COOKIE_REFRESH_TOKEN_NAME],
    role: cookie[COOKIE_ROLE_NAME] as UserRole | undefined,
    setTokens,
    removeTokens
  };
};

export default useAuthTokens;
